import { createBrowserRouter, RouterProvider } from "react-router";
import { AuthProvider } from "./contexts/auth.js";
import { ThemeProvider } from "./contexts/theme.js";
import { RootLayout } from "./components/layout/root-layout.js";
import { HomePage } from "./routes/home.js";
import { InvitePage } from "./routes/invite.js";
import { AdminPage } from "./routes/admin.js";
import { ConnectorsPage } from "./routes/connectors.js";
import { AccountPage } from "./routes/account.js";
import { ForbiddenPage } from "./routes/forbidden.js";
import { UnavailablePage } from "./routes/unavailable.js";
import { NotFoundPage } from "./routes/not-found.js";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "invite/:token", element: <InvitePage /> },
      { path: "admin", element: <AdminPage /> },
      { path: "admin/connectors", element: <ConnectorsPage /> },
      { path: "account", element: <AccountPage /> },
      { path: "403", element: <ForbiddenPage /> },
      { path: "502", element: <UnavailablePage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}
